import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { RouterConstants } from '../../../../../core/routing/constants/app-paths.constant';
import { rejectAndApprove } from '../../Interface/review-partner.i';
import { PartnersService } from '../../../../../../app/core/routing/services/Partners_api/partners.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs/internal/Subject';
import { OemService } from '../../../../../core/routing/services/oem/oem.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Content } from '../../../../oem-portal/interface/oem-portal-interface.i';
import { Utils } from '../../../../../../app/common/utils/utils';
import { first } from 'rxjs/internal/operators/first';
import { OemConstants } from '../../../../../core/routing/services/oem/constants/oem.constants';
import { AssetLibraryConstants } from '../../../../../../../src/app/core/routing/services/asset-library/constants/asset-library.constant';
import { environment } from '../../../../../../../src/environments/environment';
import { LanguageConstants } from '../../../../../../../src/app/modules/header/constants/lang.consts';
@Component({
  selector: 'iposcen-review-comment',
  templateUrl: './review-comment.component.html',
  styleUrls: ['./review-comment.component.scss']
})
export class ReviewCommentComponent implements OnInit {
  @Input() selectedPartner;
  @Input() partnerDataReview;
  @Input() contentID;
  @Output() readonly reviewOn = new EventEmitter();
  @Output() readonly selectButton = new EventEmitter();
  @Output() readonly checkStatus = new EventEmitter();
  @Output() readonly contentsData = new EventEmitter();
  doneState: boolean = false;
  @Output() readonly config = new EventEmitter();
  approveLabel = OemConstants.APPROVELABEL;
  RejectLabel = OemConstants.REJECTLABEL;
  doneApproveLabel = OemConstants.APPROVED;
  doneRejectLabel = OemConstants.RETURNED;
  buttonLabel = OemConstants.BUTTONLABEL;
  createdBy: string;
  whichPopup;

  @Output() readonly returnBack = new EventEmitter();
  popupTitle: string;
  popupDesc: string;
  popupAction: string;
  commentData: string;
  isApproveReject: any;
  @Input() autoID: string;
  contentData: any;
  systemModelData: string;
  parsedData: any;
  singleData: boolean;
  languages: any;
  language = new Map();
  languageList = [];
  image: any;
  displayLanguage: string;
  displayName: any;
  displayLanguageList = new Map();
  displayValueList = new Map();
  contentName: string;
  systemID: string;
  languageCategory: string;
  reviewStatus: string;
  displayVal = [];
  displayLang: any;
  displayList = [];
  assetID: string;
  configurations: any;
  publishDate: string;
  expiryDate: string;
  englishLang = LanguageConstants.SELECTED_LANGUAGE_NAME;
  chineseSimplified = 'Chinese - Simplified';
  chineseTraditional = 'Chinese - Traditional';
  disvalue: string;
  comments: string;
  hasComments = false;
  pagesData: any;
  hasPagesData = false;
  imageUrl: string;
  globalSortBy: string;
  globalSortValue: string;
  page: number;
  partnerId: any;
  noData: boolean;
  contents: Content[];
  contentGroupPages = [];
  openModal = false;
  approved = false;
  pushUpdates = false;
  devicesCount : number;
  approveandPush: boolean;
  openPushApproveModal: boolean = false;
  private ngUnsubscribe = new Subject();
  isReturnPopup: boolean;
  constructor(private router: Router, private partnerService: PartnersService, private ngbModal: NgbModal,
    private oemservice: OemService) { }

  ngOnInit(): void {
    this.getContentData();
    this.globalSortBy = OemConstants.CONTENT_LAST_UPDATED;
    this.noData = false;
    this.globalSortValue = OemConstants.DESCENDING_ORDER;
    this.page = 1;
    this.createdBy = this.partnerDataReview.createdByName;
  }
  redirectToReview() {
    // this.router.navigateByUrl(RouterConstants.REVIEW_PARTNERS_LINK);
    location.assign(RouterConstants.SLASH);
  }
  getComment(data: string) {
    this.commentData = data;
  }
  closePopup(modal) {
    modal.close()
    if (this.doneState) {
      this.goBackToReview();
    }
  }
  openPopup(modal, which: string) {  
    if (which === 'approved') {
      this.approveandPush = false;
      const payload =  {"oemContent":[{
        oemContentId: this.partnerDataReview?.contentID as string,
        oemContentName: this.partnerDataReview?.contentName as string,
        showOnDevice: true
      }]}
      this.partnerService.sendApproveAndPush(payload, false)
        .pipe()
        .subscribe(response => {
          this.devicesCount = response.deviceCount;
          if (this.devicesCount === 0) {  
            this.openPushApproveModal = false;
            this.isReturnPopup = false;
            this.ngbModal.open(modal);
          } else if (this.devicesCount > 0) {
            this.openPushApproveModal = true;
            this.isReturnPopup = false;
            this.ngbModal.open(modal);
          }
        },
        error => { // do something
        }); 
    } 
        this.isApproveReject = which;
    if (which === 'returned') {
      this.isReturnPopup = true;
      this.openPushApproveModal = false;
      this.ngbModal.open(modal);
    }
    this.popupTitle = which === 'approved' ? this.approveLabel : this.RejectLabel;
    this.popupAction = which === 'approved' ? this.approveLabel : this.buttonLabel;
    this.whichPopup = which;
}
sendMail() {
  const payload: rejectAndApprove = {
    comments: this.commentData as string
  }
  this.partnerService.sendRejectAndApprove(this.partnerDataReview?.autoID, this.partnerDataReview?.contentID, this.isApproveReject, payload)
    .pipe()
    .subscribe(response => {
      this.doneState = true;
    });
}

  getContentData() {
    this.oemservice.getContentDatabyContentID(this.autoID, this.contentID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllContentResponse => {
        this.contentData = getAllContentResponse.content as Content[];
        this.contentName = this.contentData.contentName;
        this.systemID = this.contentData.systemID;
        this.publishDate = (JSON.parse(this.contentData?.configurations)) ?
        JSON.parse(this.contentData?.configurations)?.publishTime : '';
        this.expiryDate = (JSON.parse(this.contentData?.configurations)) ? 
        JSON.parse(this.contentData?.configurations)?.expireTime : '';
        this.languageCategory = this.contentData.languageCategory;
        this.reviewStatus = this.contentData.reviewStatus;
        this.configurations = JSON.parse(this.contentData.configurations);
        this.contentGroupPages.push(this.configurations.contentGroupPages);
        this.autoID = this.contentData.autoID;
        this.comments = this.contentData.comments;
        this.partnerId = this.contentData.partnerID;
        // tslint:disable-next-line:prefer-conditional-expression
        if (this.comments) {
          this.hasComments = true;
        } else {
          this.hasComments = false;
        }
        this.hasPagesData = true;
        this.assetID = this.configurations.assetID;
        this.imageUrl = environment.apiBaseUrlAsset + OemConstants.SKU_COMMON + AssetLibraryConstants.SLASH + this.autoID
          + OemConstants.SLASH_ASSETS +
          OemConstants.SLASH_THUMBNAIL + AssetLibraryConstants.SLASH + this.assetID;
        this.getThumnailByAutoId();
        try {
          this.displayName = JSON.parse(getAllContentResponse.content.displayName);
          Object.keys(this.displayName)
            .forEach((value, index) => {
              let arr;
              this.displayLanguageList.set(index, this.getLanguageByCode(value));
              arr = Array.from(this.displayLanguageList.values());
              this.displayLang = arr;

            });
          Object.values(this.displayName)
            .forEach((value, index) => {
              let arr;
              this.displayValueList.set(index, value);
              arr = Array.from(this.displayValueList.values());
              this.displayVal = arr;
            });
        } catch {
          this.disvalue = getAllContentResponse.content.displayName;
        }
        this.languages = getAllContentResponse.content.languages;
        try {
          this.languages = JSON.parse(this.languages);
          this.languages.forEach((data, index) => {
            this.language.set(index, this.getLanguageByCodeIn(data));
          });
          this.languageList = Array.from(this.language.values());
          this.displayLanguage = this.languageList.join(', ');
        } catch {
          this.displayLanguage = getAllContentResponse.content.languages;
        }
        this.systemModelData = getAllContentResponse.content.systemModels;
        try {
          this.parsedData = JSON.parse(this.systemModelData);
          this.singleData = false;
        } catch {
          this.parsedData = getAllContentResponse.content.systemModels;
          this.singleData = true;
        }
      });
  }

  getLanguageByCode(langCode) {
    return Utils.decodeLanguageByCodeout(langCode);
  }
  getLanguageByCodeIn(langCode){
    if(langCode === 'zh-cn'){
      return this.chineseSimplified
    } else if(langCode === 'zh-tw'){
      return this.chineseTraditional
    } else{
      return Utils.decodeLanguageByCodeIn(langCode)
    }
   
  }

  getThumnailByAutoId() {
    const reader = new FileReader();
    this.oemservice.getAssetByAutoIdAndAssetIdView(this.assetID, OemConstants.SLASH_THUMBNAIL, this.autoID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(imageData => {

        reader.addEventListener('load', () => {
        }, false);
        if (imageData) {
          reader.readAsDataURL(imageData);
        }
      },
        error => {
          // do something
        });
  }

  goBackToReview() {
    this.getReviewData(this.partnerId, OemConstants.SUBMITTED_STATUS);
  }

  // To get Table data when navigate to review-partner
  getReviewData(partnerId, status) {
    this.oemservice.getContentDataUsingPartnerID(this.globalSortBy, this.globalSortValue, this.page, partnerId, status)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getApprovedPartnerResponse => {
        this.contents = getApprovedPartnerResponse;
        this.selectButton.emit(getApprovedPartnerResponse.partnerName[0]);
        this.checkStatus.emit(true);
        this.contentsData.emit(this.contents);
        this.reviewOn.emit(false);
      });
  }
  // IIT3-28 Pushupdates modal changes start
  approveAndPushModal(modal) {
    modal.close();
    if (this.doneState) {
      this.goBackToReview();
    }
    this.openModal = !this.openModal;
    this.pushUpdates = !this.pushUpdates;
    this.approved = false;
    this.approveandPush = true
    this.approveModal(modal);
    setTimeout(() => {
      this.pushUpdatesModal(modal);
    }, 2000);
  }
  approveModal(modal) {
    if (!this.approveandPush) {
      modal.close();
      if (this.doneState) {
        this.goBackToReview();
      }
      this.openModal = !this.openModal;
      this.approved = !this.approved;
      this.pushUpdates = false;
    }
    const payload: rejectAndApprove = {
      comments: this.commentData as string
    }
    this.partnerService.sendRejectAndApprove(this.partnerDataReview.autoID, this.partnerDataReview.contentID, this.isApproveReject, payload)
      .pipe()
      .subscribe(response => {
        this.doneState = true;
      });
  }
  pushUpdatesModal(modal) {
    this.approveandPush = false;
    const payload =  {"oemContent":[{
      oemContentId: this.partnerDataReview?.contentID as string,
      oemContentName: this.partnerDataReview?.contentName as string,
      showOnDevice: true
    }]}
    this.partnerService.sendApproveAndPush(payload, true)
      .pipe()
      .subscribe(response => {
        this.devicesCount = response.deviceCount;
        this.doneState = true;
      },
      error => { // do something
      });
  }
  closeModal() {
    this.openModal = false;
    this.pushUpdates = false;
    this.approved = false;
    if (this.doneState) {
      this.goBackToReview();
    }
  }
}
